<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="4">
          <div class="d-flex">
            <v-checkbox class="mt-0 mr-6" label="Chính khóa" v-model="coreCurriculum" hide-details></v-checkbox>
            <v-checkbox class="mt-0" label="Bổ trợ" v-model="extraCurriculum" hide-details></v-checkbox>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col>
          <v-text-field
            v-model="className"
            clear-icon="mdi-close"
            label="Tên lớp"
            flat
            outlined
            dense
            clearable
            hide-details
            @keyup.enter="onFilterChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteGrade
            return-object
            item-text="name"
            item-value="id"
            clear-icon="mdi-close"
            clearable
            label="Khối"
            placeholder="Tất cả"
            outlined
            dense
            deletable-chips
            hide-details
            @change="gradeChanged"
          />
        </v-col>
        <v-col cols="12" md="4">
          <AutocompleteTeacherCard
            v-model="teacher"
            clearable
            clear-icon="mdi-close"
            outlined
            label="Giáo viên chủ nhiệm"
            dense
            deletable-chips
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'

export default {
  components: {
    AutocompleteGrade,
    AutocompleteTeacherCard
  },
  data: () => ({
    extraCurriculum: false,
    coreCurriculum: false,
    className: '',
    teacher: {},
    grade: {},
  }),
  methods: {
    onFilterChanged() {
      let params = {
        grade: get(this.grade, 'id'),
        title_contains: this.className,
        headTeachers: get(this.teacher, 'id'),
        _sort: 'createdAt:desc'
      }
      if (!((this.coreCurriculum && this.extraCurriculum) || (!this.coreCurriculum && !this.extraCurriculum))) {
        if (this.coreCurriculum) {
          params.type = 'coreCurriculum'
        } else if (this.extraCurriculum) {
          params.type = 'extraCurriculum'
        }
      }

      this.$emit('onFilterChanged', params)
    },
    gradeChanged(grade) {
      this.grade = grade
    }
  }
}
</script>

<style scoped></style>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
